// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"cc5fd74c","506":"9a77614a","584":"bf9a0968","761":"a76bd507","806":"de0e3102","855":"dee3d729"}[chunkId] + ".chunk.js";
};